<template>
    <div
        v-if="origin"
        style="text-align: center;"
    >
        <i 
            class="fa fa-hand-pointer-o"
            style="font-size: 30px;"
        />
    </div>
    <div
        v-else
        :class="{'active': isHovered, 'current': isEdited}"
        @mousedown="triggerFocus($event, data.id)" 
    >
        <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
        >
          <tr>
            <td align="center">
            <table
                ref="contentWrapper"
                border="0"
                cellspacing="0"
                cellpadding="0"
            >
                <tr>
                    <td
                        align="center"
                        :style="{'color': computedFgColor, 'font-size': computedFontSize}"
                    >
                        <span
                            v-if="isEdited"
                            ref="btnwrapper"
                            style="text-decoration: none; text-decoration: none; display: inline-block;" 
                            :style="data.style"
                        >
                            <ckeditor
                                ref="ck"
                                v-model="data.content"
                                :params="editorConfig"
                                :blockid="data.id"
                                @ready="repositionToolbar"
                                @input="repositionToolbar"
                            />
                        </span>
                        <a 
                            v-else
                            ref="editable"
                            target="_blank" 
                            style="text-decoration: none; text-decoration: none; display: inline-block;"
                            :data-blockid="data.id"
                            :href="data.href || '#'" 
                            :style="data.style"
                            @click.prevent=""
                        >
                            <div v-html="data.content || 'Текст...'" />
                        </a>
                    </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        <blockparams
            v-if="isEdited || isForced"
            :placement="'bottom'"
            v-bind="{data: data, type: 'button', container: this.$el}"
            @update="update"
        />
        <block-styles 
            v-if="(isEdited || isForced)" 
            :data="data"
            :wrapper="$refs.contentWrapper"
            @change="updateStyles" 
        />
    </div>
</template>

<script>
    import ComponentMixin from './Component.vue'
    import CKEditorMixin from './CKEditorMixin.vue'
    import BlockStyles from './BlockStyles.vue'

    export default {
        name: 'Button',
        components: {'block-styles': BlockStyles},
        mixins: [ComponentMixin, CKEditorMixin],
        props: {
            'bindedStyles': {
                type: Array,
                default: function () { return [
                    'borderRadius', 'backgroundColor', 'borderStyle', 'borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderColor', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'backgroundImage', 'backgroundSize', 'backgroundRepeat'
                ] }
            },
        },
        data: function() {
            return {
                content: this.data.content || '',
                editorConfig: {
                    toolbar: [
                        { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'TextColor', ] },
                        { name: 'styles', items: ['Font', 'FontSize' ] },
                        { name: 'colors', items: ['EmojiList',  'CustomTag']},
                        { name: 'format', items: ['RemoveFormat']},
                    ],
                    language: 'ru',
                    extraPlugins: 'templatetag,sharedspace,emojilist,utmlink,closedialogoutside,onchange,sourcedialog', 
                    font_names: 'Sans; Serif; Monospace; Fantasy;',
                    forcePasteAsPlainText: true,
                    enterMode : CKEDITOR.ENTER_BR,
                    shiftEnterMode: CKEDITOR.ENTER_BR,
                    font_defaultLabel: 'Шрифт',
                    removePlugins: 'elementspath,resize,emoji,link,sourcearea,balloonpanel,balloontoolbar',
                    removeButtons: '',
                    resize_enabled: false,
                    sharedSpaces: {top: 'ckeditor-container'},
                    fillEmptyBlocks: false,
                    tabSpaces: 0,
                    forcePasteAsPlainText: true,
                    template_tags: this.$root.templateTags, 
                    emoji: this.$root.emoji,
                    emojiKey: this.$root.siteId, 
                }
            }
        },

        watch: {
            content: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.update(this.data.id, this.data);
                    }
                }
            },
            triggered: {
                handler: function(newVal, oldVal) {
                    if (newVal) {
                        this.isEdited = true;
                    } else {
                        this.isEdited = false;
                    }
                }
            },
            isEdited: {
                handler: function(newVal, oldVal) {
                    if (this.$refs.btnwrapper) {
                        this.setContrastingFgColor(this.$refs.btnwrapper);
                    }
                }
            },
        },
        mounted: function() {
            let palette = [];
            if (this.$root.palette) {
                for (let c of this.$root.palette) {
                    palette.push(c.replace('#', ''));
                }   
                this.editorConfig.colorButton_colors = palette.join(','); 
            }
            this.setFont();
        },
        updated: function() {
            this.setFont();
        },
        methods:{
            setFont: function() {
                if (this.$refs.btnwrapper) {
                    this.setContrastingFgColor(this.$refs.btnwrapper);
                }

                let fs = window.getComputedStyle(this.$el, null).getPropertyValue("font-size");

                if (parseInt(fs) <= 1) {
                    this.computedFontSize = '12px'; 
                } else {
                    this.computedFontSize = fs; 
                }
            },
            update: function(id, data, event) {
                this.$emit('update', id, data, event);
            },
            updateStyles: function(data) {
                this.update(this.data.id, {'style': data});
                this.$forceUpdate();
            },
        }
    }
</script>

